import type {FileRecord,ReaderContext} from '@reados/contracts';

export const SAMPLE_BOOK_NAME='线性代数入门.pdf';
// Conversations and chat originals live outside the library, so they do not count as materials.
export const hasLibraryMaterial=(files:FileRecord[])=>files.some(file=>file.storage!=='chat_attachment');

/** Starter questions stay scoped to the reading position so a first click never asks for a whole book or video. */
export function starterPrompts(context:ReaderContext):string[]{
 const content=context.workspace?.content,item=content?.focused??content?.visible[0];
 if(!item)return [];
 if(item.kind==='pdf'){
  const metadata=item.position?.metadata;
  // Structure metadata arrives after the reader loads it; unknown structure must not offer regeneration.
  return ['这一章讲了什么？','解释这一页',...(metadata&&!(metadata.hasClickableOutline&&metadata.hasKnowledgeMap)?['生成书本页码、目录、知识地图']:[])];
 }
 if(item.kind==='video')return ['这一段讲了什么？','解释当前画面'];
 return [];
}
